export { interpolateOkhsl, interpolateOkhslLong, interpolateOkhslLine } from './interpolate-okhsl.js';
export { interpolateHsluv, interpolateHsluvLong, interpolateHsluvLine } from './interpolate-hsluv.js';
export { interpolateHslLine } from './interpolate-hsl-as-lab.js';
